export default __webpack_public_path__ + "static/media/logoPMSession.826d993c.png";